import { defineMessages } from 'react-intl';

export const messages: {
	designLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	designLabel: {
		id: 'dynamic-cards-search-page.design-search-result.label',
		defaultMessage: 'Design',
		description:
			'Design search result label that is shown as part of the metadata below the design title in the search results, for example "Design • Updated 2 hours ago"',
	},
});
